const styles = {
    buttons: {
        float: 'right'
    },
    container: {
        position: 'relative',
        margin: '-23px 0 0 -5px',
        height: 'calc(100vh - 57px)'
    },
    map: {
        height: 300
    },
    rightIcon: {
        position: 'absolute',
        right: 10
    },
    mapFull: {
        height: '80vh'
    }
    /*
    map: {
        verticalAlign: 'top',
        display: 'inline-block',
        position: 'relative',
        height: 300,
        width: '95%',
        left: 0
    },
    lateralavatardiv: {
        display: 'inline-block',
        width: '5%',
        verticalAlign: 'top',
        position: 'relative'
    },
    lateralavatar: {
        display: 'block',
        margin: 'auto',
        backgroundColor: 'none',
        borderRadius: 0
    },
    lateralbox: {
        padding: 0,
        height: 300,
        verticalAlign: 'top',
        backgroundColor: green400,
        textAlign: 'right'
    }*/
};

export default styles;



// WEBPACK FOOTER //
// src/containers/openexplore/PointPage/PointPage.css.js